<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    title: String,
    titleT: String,
  },

  data: function () {
    return {
      tabs: [],
    }
  },

  computed: {
    titleComputed: function () {
      if (this.titleT) {
        return this.$t(this.titleT)
      }
      return this.title
    },
  },

  methods: {
    addTab: function (tab) {
      if (!tab.number) {
        if (this.tabs) {
          tab.number = this.tabs.length + 1
        } else {
          tab.number = 1
        }
      }
      this.tabs.push(tab)
    },
  },

  provide: function () {
    return {
      addTab: this.addTab,
    }
  },
}
</script>
<template>
  <div id="main-content" class="main-content">
    <div class="card">
      <div v-if="tabs.length > 0" class="nav-submenu d-flex flex-wrap">
        <div v-for="tab in tabs" class="nav-submenu-link">
          <a
            v-if="!tab.active"
            class="nav-link fs-16 text-uppercase"
            :href="tab.href"
            :class="tab.disabled ? 'disabled' : ''"
          >
            <span class="nav-title"
              ><span class="badge badge-pill badge-default">{{ tab.number }}</span> {{ tab.titleComputed }}</span
            >
          </a>
          <span v-if="tab.active" class="nav-link active fs-16 text-uppercase">
            <span class="nav-title"
              ><span class="badge badge-pill badge-default">{{ tab.number }}</span> {{ tab.titleComputed }}</span
            >
          </span>
        </div>
      </div>
      <h1 v-if="titleComputed" class="card-title">{{ titleComputed }}</h1>
      <div class="card-body fs-16">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
